import {latestActivity} from "../../api";

export default {
    state: {
        activities: {
            activity: {},
            tasks: []
        }
    },

    mutations: {
        setLatestActivity(state, payload) {
            console.log('setLatestActivity payload =', payload);
            state.activities = payload
        },

        clearLatestActivity(state) {
            state.activities = {
                activity: {},
                tasks: []
            };
        }
    },

    actions: {
        fetchLatestActivity(context, {daysBack = 3, group}) {
            return latestActivity(context.getters.getToken.jwt, {back: daysBack, group})
                    .then(response => context.commit('setLatestActivity', response.data))
        },

    }

}